<template>

  <div 
    v-if="props.isOfficial || props.isPremium"
    :class="['u-label', `position-${props.position}`, `size-${props.size}`]"> 

    <img loading="lazy" 
      v-if="props.isOfficial"
      :class="['img-label']" 
      src="/images/label-official.svg"
      alt="Official Brand Representative"
      title="Official Brand Representative"
      />

    <img loading="lazy" 
      v-else-if="props.isPremium"
      :class="['img-label']" 
      src="/images/label-premium.svg"
      alt="Premium account"
      title="Premium account"
      />

  </div>

</template>


<script setup lang="ts">

const positions = [
  'base',
  'absolute',
]

const sizes = [
  'tiny',
  'small',
  'medium',
  'big',
]
 
interface PageProps {
  size?: typeof sizes[number]
  position?: typeof positions[number]
  isOfficial?: boolean
  isPremium?: boolean
}

const props = withDefaults(defineProps<PageProps>(), {
  size: 'medium',
  position: 'base',
  isOfficial: false,
  isPremium: false,
})


</script>
 

 
<style scoped>
 
.u-label{
  position: relative;
  display: inline-block;
}

.u-label{
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1/1;
}

.u-label.size-tiny{
  width: 10px;
  height: 10px;
}

.u-label.size-small{
  width: 14px;
  height: 14px;
  vertical-align: middle;  
  margin-top: -4px;
}

.u-label.size-medium{
  width: 20px;
  height: 20px;
  vertical-align: middle;  
  margin-top: -4px;
}

.u-label.size-big{
  width: 30px;
  height: 30px;
  vertical-align: middle;  
  margin-top: -4px;
}

.u-label.position-absolute{
  position: absolute;
  bottom: 3px;
  right: 1px;
}

.u-label .img-label{
  width: 100%;
}

</style>